import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-4">
      <div className="container mx-auto text-center">
        <p>Made by Ej Agojo</p>
      </div>
    </footer>
  );
};

export default Footer;